import { ParamsValidator } from "@whilecat/core/tasks/validators/params-validator.js";
import { requireNotNull } from "@whilecat/core/utils/validation.js";
import type { TemplateResult } from "lit";

export type TextParams = {
    content: TemplateResult;
    customCompletionEvent?: string | undefined;
};

export class TextParamsValidator extends ParamsValidator<TextParams> {
    validate(params: TextParams): void {
        requireNotNull(params.content);
    }
}
